<template>
  <div>
    <the-w2-dialog
      :visible.sync="visible"
      :title="cfg.title"
      :width="cfg.width"
      :closeOnClickModal="false"
    >
      <iframe class="w2-org-iframe" :src="cfg.url"></iframe>
    </the-w2-dialog>
  </div>
</template>

<script>
import TheW2Dialog from "@/w2/components/dialog";
export default {
  components: {
    TheW2Dialog,
  },
  data() {
    return {
      visible: false,
      cfg: {},
    };
  },
  methods: {
    close() {
      if (this.visible) return (this.visible = false);

      let el = this.$el;
      this.$nextTick(() => document.body.removeChild(el)); // 移除当前el
    },
  },
  mounted() {
    this.visible = true;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w2-org-iframe {
  border: none;
  width: 100%;
  height: 400px;
}
::v-deep .dialog_content {
  padding: 2px;
}
</style>
